import g from "../assets/p.png";
import s from "../assets/5.png";
import ge from "../assets/4.png";
import sp from "../assets/g.png";
import d from "../assets/5.png";
import gh from "../assets/7.png";
import da from "../assets/8.png";
import dal from "../assets/3.png";
import quote from "../assets/quote.png";
import sign from "../assets/sign.png";
import dala from "../assets/10.png";
import award01 from "../assets/12.png";
import award02 from "../assets/13.png";
import award03 from "../assets/14.png";
import award04 from "../assets/15.png";
import award05 from "../assets/16.png";
import laurels from "../assets/20.png";
import gallery01 from "../assets/6.jfif";
import gallery02 from "../assets/5.jpg";
import gallery03 from "../assets/6.jpg";
import gallery04 from "../assets/1.jpeg";
import gallery05 from "../assets/39.jpg";
import gallery06 from "../assets/2.jfif";
import gallery07 from "../assets/38.jpg";
import gallery08 from "../assets/37.jpg";
import gallery09 from "../assets/36.jpg";
import gallery10 from "../assets/17.jpg";
import gallery11 from "../assets/15.jpg";
import gallery12 from "../assets/19.jpg";
import gallery13 from "../assets/3.jfif";
import gallery14 from "../assets/4.jfif";
import gallery15 from "../assets/13.jpg";
import dalaj from "../assets/s.jpg";
import gericht from "../assets/11.png";

export default {
  //   bg,
  //   chef,
  //   G,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  gallery10,
  gallery11,
  gallery12,
  gallery13,
  gallery14,
  gallery15,
  //   knife,
  //   logo,
  //   menu,
  //   overlaybg,
  //   spoon,
  //   welcome,
  //   findus,
  laurels,
  award01,
  award02,
  award03,
  award04,
  award05,
  //   sign,
  gericht,
  g,
  s,
  ge,
  sp,
  d,
  gh,
  da,
  dal,
  quote,
  sign,
  dala,
  dalaj,
};
